module.exports = __webpack_public_path__ + "static/media/events_01.da7a7357.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_01.jpg
// module id = 5919
// module chunks = 0